const inputRef = document.querySelector('.search-form');
const pageHomeBtn = document.querySelector('.js-button-home');
const pageLibaryBtn = document.querySelector('.js-button-libary');
const headerRef = document.querySelector('.header');
const headerLogoBtn = document.querySelector('.header-logo');
const formRef = document.querySelector('.search-input');
const movieList = document.querySelector('.page-film');
const buttonSearchRef = document.querySelector('.search-button');
const body = document.querySelector('body');
const footer = document.querySelector('footer');
const footertext = document.querySelector('.js-footer');
const footertextlink = document.querySelector('.js-footer-link');
const footercolor = document.querySelector('.js-footer-color');
const change = document.getElementById('theme-switch-toggle');
const linkGoit = document.querySelector('.js-goit');

const teamLink = document.querySelector('.footer__link');
const teamBackdrop = document.querySelector('.team__backdrop');
const closeTeamBtn = document.querySelector('.team__modal--btn-close');
const galleryTps = document.querySelector('.container');
const watchedBtn = document.querySelector('.watched-js');
const queueBtn = document.querySelector('.queue-js');
const libraryBox = document.querySelector('.library-box');


export {
  movieList,
  inputRef,
  pageHomeBtn,
  pageLibaryBtn,
  headerRef,
  formRef,
  buttonSearchRef,
  body,
  footer,
  footertext,
  footertextlink,
  footercolor,
  change,
  linkGoit,
  headerLogoBtn,
  teamLink,
  teamBackdrop,
  closeTeamBtn,
  galleryTps,
  watchedBtn,
  queueBtn,
  libraryBox,
};

